export const collectionMutations = (adapter, key = 'collection') => {
  return {
    upsertMany(state, payload) {
      state[key] = adapter.upsertMany(payload, state[key]);
    },
    upsertOne(state, payload) {
      state[key] = adapter.upsertOne(payload, state[key]);
    },
    removeOne(state, payload) {
      state[key] = adapter.removeOne(payload, state[key]);
    },
  }
}
